export default "__VITE_ASSET__9398e01b__"